export const API_URL = "/api/banner.php";
export const ADMIN_PATH = "/praxisIntern";
export const GOOGLE_MAPS_EMBED_URL = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10262.343419470539!2d8.395385391580154!3d49.98162477328949!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bd9949d5633869%3A0x654d22a0acb456b9!2sDr.med.%20Gabriele%20Wagner!5e0!3m2!1sde!2sde!4v1779371115471!5m2!1sde!2sde";






